<template>
  <div class="accodion_box accodion_transactional">
    <div class="accodion_box_tit">
      <a
        href="#target_transactional"
        data-toggle="collapse"
        aria-expanded="true"
      >
        <div class="panel-title">
          <span class="text-uppercase accordion-header-text"
            >거래내역 증빙</span
          >
          <span class="pull-right icon-arr"></span>
        </div>
      </a>
    </div>
    <div
      id="target_transactional"
      class="accodion_box_cont0 collapse in"
      role="tabpanel"
      aria-expanded="true"
    >
      <div class="accodion_box_cont cash_renewal">
        <dl class="cash_tax tab_control0 tab-area">
          <dt>
            <input
              class="amwa-radio"
              type="radio"
              name="paymentCardMode1"
              id="cash_02"
              value="CASH"
              v-model="localReceiptType"
              @change="updateReceiptInfo"
            />
            <label for="cash_02"><span>현금영수증</span></label>
          </dt>
          <dt>
            <input
              class="amwa-radio"
              type="radio"
              name="paymentCardMode1"
              id="cash_01"
              value="NO"
              checked="checked"
              v-model="localReceiptType"
              @change="updateReceiptInfo"
            />
            <label for="cash_01"><span>신청안함</span></label>
          </dt>
          <dd
            v-show="localReceiptType === 'CASH'"
            class="tab_control tab-cont-st0"
            style="display: block"
            id="cash_02_cont"
          >
            <div class="taxbill taxbill_with_bubble">
              <div class="tab-area-out">
                <div class="tab-area with50">
                  <div class="tab-head" role="tab">
                    <input
                      class="amwa-radio"
                      type="radio"
                      name="paymentCardMode2"
                      id="cash_02_01"
                      checked="checked"
                      value="INCOME_DEDUCTION"
                      v-model="localReceiptIssuanceType"
                      @change="updateReceiptInfo"
                    />
                    <label for="cash_02_01" class="focus subtax"
                      >개인 소득공제용</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="mgt20">
              <div class="tab-cont-st2 text_bubble_wrap" id="cash_02_01_cont">
                <span class="form_select-default">
                  <select
                    class="form_select cash_receipt_select"
                    v-model="localReceiptNumberType"
                    @change="updateReceiptInfo"
                  >
                    <option value="CPN">휴대폰번호</option>
                    <option value="CDN">현금영수증카드번호</option>
                  </select>
                  <input
                    type="text"
                    placeholder="숫자만 입력해 주세요."
                    :maxlength="localReceiptNumberType == 'CPN' ? 11 : 18"
                    :minlength="localReceiptNumberType == 'CPN' ? 10 : 15"
                    class="form-control form_input"
                    v-model="localReceiptIssuanceNumber"
                    @input="updateReceiptInfo"
                  />
                </span>
              </div>
            </div>
          </dd>
        </dl>
      </div>
    </div>
  </div>
  <!-- E : 거래내역 증빙 -->
</template>

<script>
export default {
  name: "PaymentReceipt",
  props: {
    receiptType: {
      type: String,
      default: "NO",
    },
    receiptIssuanceType: {
      type: String,
      default: "INCOME_DEDUCTION",
    },
    receiptNumberType: {
      type: String,
      default: "CPN",
    },
    receiptIssuanceNumber: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localReceiptType: this.receiptType || "NO",
      localReceiptIssuanceType: this.receiptIssuanceType || "INCOME_DEDUCTION",
      localReceiptNumberType: this.receiptNumberType || "CPN",
      localReceiptIssuanceNumber: this.receiptIssuanceNumber,
    };
  },
  watch: {
    receiptType(newVal) {
      this.localReceiptType = newVal;
    },
    receiptIssuanceType(newVal) {
      this.localReceiptIssuanceType = newVal;
    },
    receiptNumberType(newVal) {
      this.localReceiptNumberType = newVal;
    },
    receiptIssuanceNumber(newVal) {
      this.localReceiptIssuanceNumber = newVal;
    },
  },

  methods: {
    updateReceiptInfo() {
      this.$emit("update-receipt-info", {
        receiptType: this.localReceiptType,
        receiptIssuanceType: this.localReceiptIssuanceType,
        receiptNumberType: this.localReceiptNumberType,
        receiptIssuanceNumber: this.localReceiptIssuanceNumber,
      });
    },
  },
};
</script>

<style>
</style>